import dayjs, { type Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/zh-cn'
import type { VNodeChild } from 'vue'

dayjs.extend(customParseFormat)
export type PickerValue = string | Dayjs
export type PickerFormat = string | ((value: Dayjs) => string) | (string | ((value: Dayjs) => string))[]
export interface DateRangePreset { label: VNodeChild; value: [Dayjs, Dayjs] | (() => [Dayjs, Dayjs]) }

export function readPickerValue(value: PickerValue | null | undefined, valueFormat?: string): Dayjs | null {
  if (value == null || value === '') return null
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null
  if (!valueFormat) throw new TypeError('字符串日期必须指定 valueFormat；未指定时请绑定 Dayjs')
  const date = dayjs(value, valueFormat, true)
  return date.isValid() ? date : null
}
export function writePickerValue(value: Dayjs, valueFormat?: string): PickerValue { return valueFormat ? value.format(valueFormat) : value }
export function displayPickerValue(value: Dayjs | null, format: PickerFormat): string {
  if (!value) return ''
  const first = Array.isArray(format) ? format[0] : format
  return typeof first === 'function' ? first(value) : value.format(first)
}
export function parsePickerInput(text: string, format: PickerFormat): Dayjs | null {
  const formats = (Array.isArray(format) ? format : [format]).filter((item): item is string => typeof item === 'string')
  for (const candidate of formats) { const date = dayjs(text, candidate, true); if (date.isValid()) return date }
  return null
}
export function calendarDays(view: Dayjs, locale = 'zh-cn'): Dayjs[] {
  const start = view.locale(locale).startOf('month').startOf('week')
  return Array.from({ length: 42 }, (_, index) => start.add(index, 'day'))
}
/** Callbacks evaluate at selection time, so an open page never freezes yesterday or last month's start. */
export function createDefaultDateRangePresets(): DateRangePreset[] {
  return [
    { label: '今天', value: () => [dayjs().startOf('day'), dayjs().startOf('day')] },
    { label: '昨天', value: () => { const date = dayjs().subtract(1, 'day').startOf('day'); return [date, date] } },
    { label: '最近7天', value: () => [dayjs().subtract(6, 'day').startOf('day'), dayjs().startOf('day')] },
    { label: '最近30天', value: () => [dayjs().subtract(29, 'day').startOf('day'), dayjs().startOf('day')] },
    { label: '本月', value: () => [dayjs().startOf('month'), dayjs().startOf('day')] },
    { label: '上月', value: () => { const date = dayjs().subtract(1, 'month'); return [date.startOf('month'), date.endOf('month').startOf('day')] } }
  ]
}
